import CenterFocusStrongIcon from '@mui/icons-material/CenterFocusStrong'
import IconButton from '@mui/material/IconButton'
import Paper from '@mui/material/Paper'
import { alpha } from '@mui/material/styles'
import Tooltip from '@mui/material/Tooltip'
import { MapControl, ControlPosition, useMap } from '@vis.gl/react-google-maps'
import PropTypes from 'prop-types'
import React from 'react'

const PAPER_SX = {
  borderRadius: '2px',
  boxShadow: theme => `0 1px 4px -1px ${alpha(theme.palette.common.black, theme.palette.mode === 'dark' ? 0.6 : 0.3)}`,
  width: 40,
  height: 40,
  pointerEvents: 'auto',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}
const BUTTON_SX = { width: '100%', height: '100%', borderRadius: '2px', bgcolor: 'background.paper', color: 'text.primary' }

// The tooltip opens away from whichever edge the button is docked to, or it would
// hang off the map.
const LEFT_POSITIONS = [ControlPosition.LEFT_TOP, ControlPosition.LEFT_CENTER, ControlPosition.LEFT_BOTTOM]

// topOffset (px) drops the button below the route A | All | route B toggle that shares the top-right corner on the two-route maps.
// JSDoc so TS consumers see `position` as a number rather than narrowing to the
// default's literal value.
/** @param {{ fitBounds?: () => void, position?: number, topOffset?: number }} props */
const FitBoundsControl = ({ fitBounds, position = ControlPosition.RIGHT_TOP, topOffset = 0 }) => {
  const map = useMap()

  if (!map) return null

  const paperSx = { ...PAPER_SX, m: '10px', ...(topOffset ? { mt: `${topOffset}px` } : null) }

  return (
    <MapControl position={position}>
      <Paper elevation={0} sx={paperSx}>
        <Tooltip placement={LEFT_POSITIONS.includes(position) ? 'right' : 'left'} title="Center map on routes">
          <IconButton sx={BUTTON_SX} onClick={fitBounds}>
            <CenterFocusStrongIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Paper>
    </MapControl>
  )
}

FitBoundsControl.propTypes = {
  fitBounds: PropTypes.func,
  position: PropTypes.number,
  topOffset: PropTypes.number,
}

export default FitBoundsControl
